import { styled } from "@mui/material";

const MainWrapper = styled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  overflow: 'hidden',
  width: '100%',
  backgroundColor: '#e6e8ec',
}));

export default MainWrapper;